export default __webpack_public_path__ + "static/chill_logo_og-7615993c4ec4fbaf9b8b545db553d8d3.jpeg";